<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="标的概况" name="tab1">
      <p class="tab_title">标的概况</p>
      <el-form label-width="100px">

        <el-form-item label="项目编号" v-if="type == 1">
          {{ data.code }}
        </el-form-item>

        <el-form-item label="标的名称">
          {{ data.name }}
        </el-form-item>

        <el-form-item label="主图" v-if="type != 1">
          <el-image style="width: 100px; height: 100px; margin-right: 10px" v-for="(item, index) in imgList"
            :key="index" :src="item" :preview-src-list="imgList"></el-image>
        </el-form-item>

        <el-form-item label="项目领域">
          {{ data.projectDomain }}
        </el-form-item>

        <el-form-item label="知识产权类别">
          {{
            data.propertyCategory == "其他"
              ? data.propertyCategoryExtra
              : data.propertyCategory
          }}
        </el-form-item>

        <el-form-item label="专利类别" v-show="data.propertyCategory == '专利'">
          {{ data.patentType }}
        </el-form-item>

        <el-form-item label="权利人">
          {{ data.obligee }}
        </el-form-item>

        <el-form-item label="发明人">
          {{ data.inventor }}
        </el-form-item>

        <el-form-item label="权证编号">
          {{ data.warrantCode }}
        </el-form-item>

        <el-form-item label="项目简介">
          {{ data.projectBrief }}
        </el-form-item>

        <el-form-item label="专利数量" v-if="type != 1">
          <div class="flex-left flex-wrap">
            {{ zlsl }}

            <div style="margin-left: 20px">国内发明: {{ ipc.gnfm || 0 }}</div>

            <div style="margin-left: 20px">
              国内实用新型: {{ ipc.gnsyxx || 0 }}
            </div>

            <div style="margin-left: 20px">
              国内外观设计: {{ ipc.gnwgsj || 0 }}
            </div>

            <div style="margin-left: 20px">国外发明: {{ ipc.gwfm || 0 }}</div>

            <div style="margin-left: 20px">
              国外实用新型: {{ ipc.gwwgsj || 0 }}
            </div>

            <div style="margin-left: 20px">
              国外外观设计: {{ ipc.gwwgsj || 0 }}
            </div>

            <div style="margin-left: 20px">PCT: {{ ipc.pct || 0 }}</div>
          </div>
        </el-form-item>

        <el-form-item label="IP总数" v-if="type != 1">
          <div class="flex-left">
            {{ ipzs }}

            <div style="margin-left: 20px">专利数量: {{ zlsl }}</div>

            <div style="margin-left: 20px">商标: {{ ipc.sb || 0 }}</div>

            <div style="margin-left: 20px">版权: {{ ipc.bq || 0 }}</div>

            <div style="margin-left: 20px">布图设计: {{ ipc.btsj || 0 }}</div>

            <div style="margin-left: 20px">技术秘密: {{ ipc.jsmm || 0 }}</div>

            <div style="margin-left: 20px">其他: {{ ipc.qt || 0 }}</div>
          </div>
        </el-form-item>

        <el-form-item label="附件" v-if="type != 1">
          <div v-for="(item, index) in data.attachments" :key="index">
            <a :href="item.url" target="_blank">
              {{ item.name }}
            </a>
          </div>
        </el-form-item>

        <el-form-item label="公告发布附件">
          <div v-for="(item, index) in attachmentlist" :key="index">
            <a :href="item.url" target="_blank">
              {{ item.name }}
            </a>
          </div>
        </el-form-item>

        <el-form-item label="图片" v-if="type == 1">
          <!-- <img
            :src="item"
            v-for="(item, index) in imgList"
            :key="index"
            style="height: 180px; margin-right: 20px"
            :preview-src-list="imgList"
          /> -->
          <el-image v-for="(item, index) in imgList" :key="index" style="height: 180px; margin-right: 20px" :src="item"
            :preview-src-list="[item]">
          </el-image>
        </el-form-item>
      </el-form>
    </el-tab-pane>

    <el-tab-pane label="共有或他项权利情况" name="tab2">
      <p class="tab_title">共有或他项权利情况</p>
      <el-form label-width="180px">
        <el-form-item label="共有情况">
          {{ data.mutualCondition }}
        </el-form-item>

        <el-form-item label="许可、抵押等他项权利情况">
          {{ data.rightsSituation }}
        </el-form-item>

        <el-form-item label="是否行使优先受让权">
          {{ data.rightOfFirstRefusal }}
        </el-form-item>

        <el-form-item label="其他披露信息">
          {{ data.discloseInformation }}
        </el-form-item>
      </el-form>
    </el-tab-pane>

    <el-tab-pane label="申请人概况" name="tab3">
      <p class="tab_title">申请人概况</p>
      <el-form label-width="130px">
        <el-form-item label="申请人类型">
          {{ data.applicantType }}
        </el-form-item>
        <!-- 个人 -->
        <div v-show="data.applicantType == '自然人'">
          <el-form-item label="转让方名称">
            {{ data.transferorName }}
          </el-form-item>

          <el-form-item label="证件号码">
            {{ data.idcardNumber ? idNumChange(data.idcardNumber) : '' }}
          </el-form-item>

          <el-form-item label="邮寄地址">
            {{ data.actualAddress ? data.actualAddress.replace(/[0-9]+/g, "***") : data.actualAddress }}
          </el-form-item>

          <el-form-item label="联系方式">
            {{ data.applicantType == '自然人' ? data.phone.slice(0, 3) + '****' + data.phone.slice(7) : data.phone }}
          </el-form-item>

          <el-form-item label="所属区域">
            {{ data.region }}
          </el-form-item>

          <el-form-item v-if="type != 1" :label="data.region == '境外' ? '国家' : '省/市/县(区)'">
            {{ data.regionName }}
          </el-form-item>
        </div>
        <!-- 企业或第三方 -->
        <div v-show="data.applicantType == '国资' || data.applicantType == '非国资'
          ">
          <el-form-item label="转让方名称">
            {{ data.transferorName }}
          </el-form-item>
          <el-form-item label="所属区域">
            {{ data.region }}
          </el-form-item>
          <el-form-item label="企业类型">
            {{ data.enterpriseType }}
          </el-form-item>
          <el-form-item label="注册地址">
            {{ data.registeredAddress }}
          </el-form-item>
          <el-form-item label="法人代表">
            {{ data.legalPerson }}
          </el-form-item>
          <el-form-item label="统一社会信用代码">
            {{ data.creditCode }}
          </el-form-item>
          <el-form-item label="联系人" v-if="type != 1">
            {{ data.linkman }}
          </el-form-item>
          <el-form-item label="联系电话" v-if="type != 1">
            {{ data.contactNumber }}
          </el-form-item>

          <el-form-item :label="data.region == '境外' ? '国家' : '省/市/县(区)'" v-if="type != 1">
            {{ data.regionName }}
          </el-form-item>

          <el-form-item label="内部审议情况" v-if="type != 1">
            {{ data.innerDecision }}
            <span v-if="data.innerDecision == '其他'">( {{ data.innerDecisionExtra }} )</span>
          </el-form-item>
        </div>
      </el-form>
    </el-tab-pane>

    <el-tab-pane label="交易条件" name="tab4">
      <p class="tab_title">交易条件</p>
      <el-form label-width="160px">
        <el-form-item label="交易方式">
          {{ data.dealWay }}
        </el-form-item>
        <el-form-item label="地域范围" v-show="data.district">
          {{ data.district }}
        </el-form-item>
        <el-form-item label="许可期限" v-show="data.permissionTime">
          {{ data.permissionTime }}
        </el-form-item>

        <el-form-item label="作价入股金额" v-show="data.stockPrice">
          {{ data.stockPrice }}万元
        </el-form-item>
        <el-form-item label="作价占股比例" v-show="data.stockComponent">
          {{ data.stockComponent }}%
        </el-form-item>

        <el-form-item label="与许可相关的其他条件" v-show="data.licensingConditions">
          {{ data.licensingConditions }}
        </el-form-item>

        <el-form-item label="交易底价">
          <span v-if="data.floorPrice || data.floorPrice == 0">人民币{{ data.floorPrice }}万元</span>
          <span v-else-if="!data.floorPrice">面议</span>
        </el-form-item>

        <el-form-item label="价款支付方式">
          {{ data.paymentType }}
          <span v-show="data.paymentType && data.paymentType2">、</span>
          {{ data.paymentType2 }}
        </el-form-item>

        <el-form-item label="付款要求">
          {{ data.paymentDemand }}
        </el-form-item>

        <el-form-item label="与交易相关的其他条件">
          {{ data.otherCondition }}
        </el-form-item>
      </el-form>
    </el-tab-pane>

    <el-tab-pane v-if="type != 1" label="信息发布" name="tab5">
      <p class="tab_title">信息发布</p>

      <el-form label-width="100px">
        <el-form-item label="公告时间">
          <span v-show="data.announcementTime">自公告之日期{{ data.announcementTime }}个工作日</span>
        </el-form-item>
        <el-form-item label="挂牌期满">
          <!-- {{ data.listedTimeEnd }} -->
          <span v-show="data.listedTimeEnd == 1">更变公告内容，重新挂牌</span>
          <span v-show="data.listedTimeEnd == 2">延长信息发布，不变更挂牌条件，按照{{
            data.day1
          }}个工作日为一个周期，延长{{ data.delay1 }}个周期</span>
          <span v-show="data.listedTimeEnd == 3">延长信息发布，不变更挂牌条件，按照{{
            data.day2
          }}个工作日为一周期，直至征集到承租方</span>
          <span v-show="data.listedTimeEnd == 4">信息发布终结</span>
        </el-form-item>

        <el-form-item label="信息发布渠道">
          {{ data.accessInformation | accessInformationChange }}
        </el-form-item>

        <el-form-item label="发布期满后">
          <div>
            1、如征集到一家符合条件的意向受让方，在通过受让资格确认后，该意向受让方即为受让方应当以不低于交易底价受让标的；
          </div>
          <div>
            2、如征集到两家及以上符合条件的意向受让方，则采取以下方式确定最终受让方和受让价格。
          </div>
          {{ data.releaseTimeEnd }}
        </el-form-item>
      </el-form>
    </el-tab-pane>

    <el-tab-pane label="意向受让方资格" name="tab6">
      <p class="tab_title">意向受让资格</p>
      <el-form label-width="100px">
        <el-form-item label="受让方资格">
          <div>
            1、意向受让方应为依法设立并有效存续的境内外经济组织或具有完全民事行为能力的自然人；
          </div>
          <div>2、意向受让方应具有良好的财务状况和支付能力</div>
          <div>{{ data.assigneeQualification }}</div>
          <div>3、联合受让</div>
          <div>{{ data.theJoint }}</div>
          <div>
            4、意向受让方应具有良好的商业/个人信用，守法经营，诚实守信。近年来的经营活动中无不正当竞争手段取得经营权的记录；银行信用良好，无不良贷款记录；依法纳税、依法缴纳社会保障资金，无违反国家规定、损害合作方的不良记录。
          </div>
        </el-form-item>
      </el-form>
    </el-tab-pane>

    <el-tab-pane label="保证金" name="tab7">
      <p class="tab_title">保证金</p>
      <el-form label-width="130px">
        <el-form-item label="是否需要保证金">
          {{ data.isEarnestMoney }}
        </el-form-item>

        <div v-show="data.isEarnestMoney == '是'">
          <el-form-item label="交纳金额">
            {{ data.earnestMoney }}万元
          </el-form-item>

          <el-form-item label="交纳截止时间">
            {{ data.closingTime | dateYMD }}
          </el-form-item>

          <el-form-item label="交纳方式">
            {{
              data.payTheWay == "其他" ? data.payTheWayExtra : data.payTheWay
            }}
          </el-form-item>

          <el-form-item label="保证金事项">
            {{ data.marginMatters }}
          </el-form-item>
          <el-form-item label="保证金处理">
            {{ data.marginProcessing }}
          </el-form-item>
        </div>
      </el-form>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { getRequest } from "../api/api";
export default {
  props: ["id", "type"],
  data() {
    return {
      activeName: "tab1",
      data: {},
      imgList: [],
      ipc: {},
      attachmentlist: []
    };
  },
  computed: {
    zlsl() {
      let a1 = parseInt(this.ipc.gnfm) || 0;
      let a2 = parseInt(this.ipc.gnsyxx) || 0;
      let a3 = parseInt(this.ipc.gnwgsj) || 0;
      let a4 = parseInt(this.ipc.gwfm) || 0;
      let a5 = parseInt(this.ipc.gwsyxx) || 0;
      let a6 = parseInt(this.ipc.gwwgsj) || 0;

      console.log(a1, a2, a3, a4, a5, a6);
      console.log("国外实用新型", this.ipc.gwsyxx);

      return a1 + a2 + a3 + a4 + a5 + a6;
    },
    ipzs() {
      let zs = 0;
      for (var i in this.ipc) {
        zs += parseInt(this.ipc[i]) || 0;
      }
      zs -= parseInt(this.ipc.pct) || 0;
      zs -= parseInt(this.ipc.total1) || 0;
      zs -= parseInt(this.ipc.total2) || 0;
      return zs;
    },
  },
  filters: {
    accessInformationChange(value) {
      if (value == 1) {
        return "公开挂牌-意向挂牌";
      } else if (value == 2) {
        return "公开挂牌-正式挂牌";
      } else if (value == 3) {
        return "非公开挂牌";
      } else {
        return value;
      }
    },
  },
  methods: {
    // 证件号码个人或多人中间屏蔽
    idNumChange(value) {
      let arr = value.split(/[,;|，、；-]/)
      let a = []
      arr.forEach(item => {
        a.push(item.replace(/^(.{3})(?:\d+)(.{4})$/, "$1******$2"))
      });
      return a.join('、')
    },

    handleClick(tab, event) {
      console.log(tab, event);
    },
    getData(id) {
      getRequest({ url: `/api/v1/markRelease/getOne/${id}` }).then((res) => {
        if ((res.errcode = 200)) {
          this.data = res.data;

          if (res.data.imageUrl) this.imgList = JSON.parse(res.data.imageUrl);

          if (res.data.ipc) this.ipc = JSON.parse(res.data.ipc);

          if (res.data.attachment) this.attachmentlist = JSON.parse(res.data.attachment)
          console.log(this.attachmentlist);
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
  },
  created() {
    this.getData(this.id);
  },
};
</script>

<style lang="scss">
.el-form {
  margin: 30px 0;
}

.tab_title {
  font-size: 18px;
  font-weight: 500;
}

.title {
  font-size: 24px;
  font-weight: bold;
  color: #1d2129;
  line-height: 32px;
  margin-bottom: 24px;
}
</style>
